var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTooth01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M11.687 3.29C8.77 3.29 9.937 2 7.02 2 3.754 2 2.937 6.516 2.937 7.806s.583 2.581 1.167 3.226c.583.645 1.166 3.226 1.166 3.226C6.048 17.268 6.437 22 8.77 22c1.32 0 1.556-4.301 1.75-5.806 0 0 .584-1.694 1.167-1.694.625 0 1.25 1.875 1.25 1.875.208 1.458.46 5.625 1.875 5.625 2.5 0 2.917-5.208 3.75-8.125 0 0 .625-2.5 1.25-3.125s1.25-1.875 1.25-3.125S20.187 2 16.687 2c-3.125 0-1.875 1.25-5 1.25"
})));
export default SvgTooth01;